import { Provider } from '@angular/core'

import { BpWidget } from './bp_widget'
import { BpHook } from './bp_hook'
import { BpExpr } from './bp_expr'
import { BpAction } from './bp_action'

export const VIEW_DIRECTIVES: Provider[] = [BpWidget, BpHook, BpExpr, BpAction]
